import { Divider, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectScheduleInsUpd } from "../../../../redux/curriculum/scheduleInsUpdSlice";
import { getOrRetrieveNamedObject, selectObjectCache } from "../../../../redux/object/objectCacheSlice";
import { useAppDispatch } from "../../../../app/hooks";
import { ObjectTarget } from "../../../../app/permissions";

const dayOfWeekName: Record<number, string> = {
    1: "Segunda",
    2: "Terça",
    3: "Quarta",
    4: "Quinta",
    5: "Sexta",
    6: "Sábado",
    7: "Domingo",
};

export function ScheduleInsUpdReview() {
    const scheduleInsUpd = useSelector(selectScheduleInsUpd);
    const schedule = scheduleInsUpd.schedule;

    const objectCacheState = useSelector(selectObjectCache);
    const dispatch = useAppDispatch();

    const classroom = getOrRetrieveNamedObject(dispatch, objectCacheState, ObjectTarget.CLASSROOM, `${schedule.classroomId}`);
    const subject = getOrRetrieveNamedObject(dispatch, objectCacheState, ObjectTarget.SUBJECT, `${schedule.subjectId}`);

    return <>
        <Typography variant="h6" gutterBottom>
            Revisão do horário
        </Typography>

        <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid size={3} sx={{ textAlign: "right" }}>
                <Typography variant="subtitle2" color="text.secondary">Sala:</Typography>
            </Grid>
            <Grid size={9}>
                <Typography sx={{ color: "darkblue" }}>{classroom?.display || schedule.classroomId}</Typography>
            </Grid>

            <Grid size={3} sx={{ textAlign: "right" }}>
                <Typography variant="subtitle2" color="text.secondary">Disciplina:</Typography>
            </Grid>
            <Grid size={9}>
                <Typography sx={{ color: "darkblue" }}>{subject?.display || schedule.subjectId}</Typography>
            </Grid>

            <Grid size={3} sx={{ textAlign: "right" }}>
                <Typography variant="subtitle2" color="text.secondary">Dia:</Typography>
            </Grid>
            <Grid size={9}>
                <Typography sx={{ color: "darkblue" }}>{dayOfWeekName[schedule.dayOfWeek] || schedule.dayOfWeek}</Typography>
            </Grid>

            <Grid size={3} sx={{ textAlign: "right" }}>
                <Typography variant="subtitle2" color="text.secondary">Início:</Typography>
            </Grid>
            <Grid size={9}>
                <Typography sx={{ color: "darkblue" }}>{schedule.startTime}</Typography>
            </Grid>

            <Grid size={3} sx={{ textAlign: "right" }}>
                <Typography variant="subtitle2" color="text.secondary">Fim:</Typography>
            </Grid>
            <Grid size={9}>
                <Typography sx={{ color: "darkblue" }}>{schedule.endTime}</Typography>
            </Grid>
        </Grid>

        <Divider sx={{ mt: 4 }} />
    </>;
}
